/*
 * ===============================================================================================================
 *                                Copyright 2024; Blue Yonder Group; Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP; INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const POLICY_DETAILS = 'Policy Details';
export const POLICY_NAME = 'Policy Name:';
export const LENGTH = 'Length';
export const MINIMUM_PASSWORD_LENGTH = 'The minimum password length is:';
export const MAXIMUM_PASSWORD_LENGTH = 'The maximum password length is:';
export const CHARACTERS = 'characters';
export const EXPIRATION_DATE = 'Expiration Date';
export const PASSWORD_EXPIRES_AFTER = 'Password expires after:';
export const DAYS = 'days';
export const NO_EXPIRATION = 'No expiration';
export const PASSWORD_CONTENTS = 'Password Contents';
export const PASSWORD_MUST = 'The password must';
export const INCLUDE = 'include';
export const EXCLUDE = 'exclude';
export const NUMBERS = 'Numbers';
export const NUMBERS_EXAMPLE = '(e.g. 1; 2; 3; 4; etc.)';
export const SPECIAL_CHARACTERS = 'Special characters';
export const SPECIAL_CHARACTERS_EXAMPLE = '(e.g. !; @; #; $; etc.)';
export const MIXED_CASE = 'Letters in mixed case';
export const MIXED_CASE_EXAMPLE = '(e.g. a; A; b; B; etc.)';
export const EXCLUDE_COMMON_PASSWORDS = 'Common unsafe passwords';
export const EXCLUDE_COMMON_PASSWORDS_EXAMPLE = '(e.g. 123456, qwuerty, etc)';
export const EXCLUDE_USER_PROFILE_INFO = 'User profile information';
export const EXCLUDE_USER_PROFILE_INFO_EXAMPLE = '(e.g username, email, first name, etc)';
export const MAX_CONSECUTIVE_LETTERS = 'Max consecutive letters';
export const PASSWORD_HISTORY = 'Password History';
export const NO_LIMIT = 'Unlimited';
export const TIMES = 'times';
export const MAX_OLD_PASSWORDS_STORED = 'Number of previous passwords remembered to prevent reuse is';
